import React, { useEffect, useState, useRef } from 'react';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import useClearStateResetFlag from '../../../utilities/hooks/useClearStateResetFlag';
import { connect } from 'react-redux';
import { reportDWH, initPage, goToPage } from './EquipmentMineSlice';
import EquipmentMain from './page/EquipmentMain';
import context from 'react-bootstrap/esm/AccordionContext';

const Main = (props) => {
  let currentView = null;

  useExtendedEffect((runSideEffects) => {
    getData();
    if (runSideEffects()) {
    }
  }, []);

  async function getData() {
    await props.initPage({ epiData: props.iContent, context: props.context });
  }

  useClearStateResetFlag();

  switch (props.page) {
    case 'equipmentMain': 
      currentView = <EquipmentMain context={props.context}></EquipmentMain>
      break;
    default:
      currentView = <div>Page not found</div>;
  };

  return (
    <div className='equipment-page'>
      {currentView}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    page: state.equipmentMinePage.page,
  };
};

const mapDispatchToProps = {
  reportDWH,
  initPage,
  goToPage,
};

export default connect(mapStateToProps, mapDispatchToProps)(Main);
